// components/AnalysisProtectedRoute.jsx
import { Navigate } from "react-router-dom";
import { useAnalysis } from './AnalysisContext';

const AnalysisProtectedRoute = ({ children }) => {
  const { analysisData } = useAnalysis();

  if (!analysisData) {
    return <Navigate to="/dog-analyzer" replace />;
  }

  return children;
};

export default AnalysisProtectedRoute;